import { IConfig } from "../models/IConfig";

export default class ConfigService {
  private static config: IConfig;

  /**
  * Load config
  * @returns 
  */
  public static async loadConfig(): Promise<void> {
    try {
      const res = await fetch(`${process.env.PUBLIC_URL}/config/config.${process.env.NODE_ENV}.json`);
      ConfigService.config = await res.json() as IConfig;
      return Promise.resolve();
    } catch (err: any) {
      return Promise.reject(err);
    }
  }

  /**
   * Get service instance
   */
   public static getConfig(): IConfig {
    return ConfigService.config;
  }
}
